import React, { useEffect, useState } from "react";
import LoaderLight from "../../atoms/loaderLight/loaderLight";
import loaderData from "../../assets/loader.json";
import { useHistory, useLocation, useParams } from 'react-router-dom';
import TransactionSuccessIcon from "../../assets/testRide/transactionSuccessIcon.svg";
import TransactionFailedIcon from "../../assets/testRide/transactionFailedIcon.svg";
import TransactionPendingIcon from "../../assets/testRide/transactionPendingIcon.svg";

import { makeAPICall } from "../../services/apiService";

import "./PosUniqueCode.scss";
import { getCookie , setCookie, postCall} from "src/utils/utils";
import axios from "axios";

const PosTransactionStatus = () => {
  const [loader, setLoader] = useState(false);
  const [isTransactionSuccess, setTransactionSuccess] = useState(false);
  const [isTransactionPending, setTransactionPending] = useState(false);
  const [isTransactionFailed, setTransactionFalied] = useState(false);
  const fromPurchaseFlow = getCookie("from_purchase_flow") || false

  const history = useHistory();
  const { search } = useLocation();

  useEffect(()=>{
    const status = new URLSearchParams(search).get("status");
     if(status == "failure"){
      setTransactionFalied(true)
     }else if(status == "success"){
      setTransactionSuccess(true)
     }
  },[])

  const getIcons = () => {
    return (
      <>
        {isTransactionSuccess ? (
          <div>
            <img
              className="transctions_img"
              src={TransactionSuccessIcon}
              alt="TransactionsSucess"
            />
          </div>
        ) : isTransactionPending ? (
          <div>
            <img
              className="transctions_img"
              src={TransactionPendingIcon}
              alt="TransactionsPending"
            />
          </div>
        ) : (
          <div>
            <img
              className="transctions_img"
              src={TransactionFailedIcon}
              alt="TransactionsFailed"
            />
          </div>
        )}
      </>
    );
  };

  const getOrderTransactionId = () => {
    let userOrdersDetails = localStorage.getItem("orderDetails");

    let orderDetails = JSON.parse(userOrdersDetails);

    let config = {
      method: "post",
      url: `api/pos/getOrderTransactionId`,
      data: {
        user_id: orderDetails?.user_details?.user_tenant_uuid,
        order_id: orderDetails?.order_details?.order_id,
        payment_type:  orderDetails?.order_details?.payment_type,
        amount_payable: orderDetails?.order_details?.amount,
        currency: "INR",
        pos_unique_code: orderDetails?.order_details?.unique_code
      },
    };

    console.log("getOrderTransactionId", config)
    makeAPICall(config)
      .then((resp) => {
        if (resp?.data?.status === "SUCCESSFUL") {
          setCookie('payu_transaction_id', resp?.data?.data?.transaction_id);
          initiatePayment(resp?.data?.data?.transaction_id);
        }
      })
      .catch((err) => {});
  };

 

  const initiatePayment = (transactionId) => {
    let userOrdersDetails = localStorage.getItem("orderDetails");

    let orderDetails = JSON.parse(userOrdersDetails);
    
    let config = {
      method: "post",
      url: `api/pos/initiatePayment`,
      headers: {
        user_id: orderDetails?.order_details?.user_id,
      },
      data: {
        utm_uuid: orderDetails?.order_details?.user_id,
        source_name: "PayU",
        amount: orderDetails?.order_details?.amount,
        currency: "INR",
        transaction_id: transactionId,
        email: orderDetails?.user_details?.email,
        first_name: orderDetails?.user_details?.name,
        product_info: orderDetails?.product_info,
        order_id: orderDetails?.order_details?.order_id,
        entity_type: "OEM",
        udf1: orderDetails?.order_details?.payment_type,
        udf2: orderDetails?.order_details?.order_id,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp?.data?.status === "success") {
          setCookie('hash_code', resp?.data?.data?.hash)
          history.push("/paymentProcess");
        }
      })
      .catch((err) => {});
  };

  const getDownButton = () => {
    const retryPayment = () => {
     // history.push("/pos-proceed-payment");
     getOrderTransactionId();
    };

    const onTransactionSuccess = () => {
      if (fromPurchaseFlow) {
        const url = JSON.parse(localStorage.getItem('env_const'))?.purchase_url || ""
        if (url) {
          postCall(`${url}/cloakCustomer`, {
            redirectUrl: "/orderDetail?show=order_detail"
          })
        }
      } else {
        history.push("/pos-customer-search");
      }
    };

    

    const onRedirectNewUnique = () => {
    console.log("onRedirectNewUnique",fromPurchaseFlow )
      if (fromPurchaseFlow) {
        const url = JSON.parse(localStorage.getItem('env_const'))?.purchase_url || ""
        if (url) {
          postCall(`${url}/cloakCustomer`, {
            redirectUrl: "/selectSavedCards"
          })
        }
      } else {
        history.push("/pos-unique-code");
      }
    };

    if (isTransactionSuccess || isTransactionPending) {
      return (
        <div>
            <button
              className={"submit_btn"}
              type="submit"
              onClick={() => onTransactionSuccess()}
              style={{bottom:'2%'}}
            >
              {isTransactionSuccess ? "Continue" : "Got it"}
            </button>
        </div>
      );
    } else if (isTransactionFailed) {
      return (
        <div>
          <button
            className={
           "payment_submit_btn"
             
            }
            type="submit"
            onClick={() => retryPayment()}
          >
            Retry Payment
          </button>
          <button
            className={
              true
                ? "payment_cancel_btn"
                : `payment_cancel_btn payment_cancel_btn_disabled`
            }
            type="submit"
            onClick={() => onRedirectNewUnique()}
            style={{ pointerEvents: loader ? "none" : "" , marginTop:15}}
          >
            Enter new unique code
          </button>
        </div>
      );
    }
  };

  const getStatusTxt = () => {
    return isTransactionSuccess
      ? "Transaction complete"
      : isTransactionPending
      ? "Processing payment"
      : "Transaction failed";
  };

  let userOrdersDetails = localStorage.getItem("orderDetails");

  let orderDetails = JSON.parse(userOrdersDetails);

  let transactionId = getCookie("payu_transaction_id");

  return (
    <>
      <div className="pos-code-main-container">
        <div className="right-container">
          <div className="vertical-center-payment">
            <div className="pos-code-container payment-containrt">
              <div className="form-container flex">
                <div className="form-controls">
                  {getIcons()}
                  <div className="payment transaction_lable" style={{position:'relative',top:10}}>
                    <div className="label">{getStatusTxt()}</div>
                    <div className="transations_sub_lable">
                      <div>
                        Transaction ID: {transactionId ? transactionId : ""}
                      </div>
                      <div>
                        Order ID: {orderDetails?.order_details?.order_id}
                      </div>
                    </div>
                  </div>
                  <div>{getDownButton()}</div>
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PosTransactionStatus;
